import ApiService2 from "./shared/ApiService2";
import "@/utils/helpers/formatacao";

const configPublico = { public: true };

export default {
  logar: async ({ login, senha }) =>
    ApiService2.post(
      "/api/autenticacao/login",
      { login: login, senha },
      configPublico
    ),
  logarComTicket: async ticket =>
    ApiService2.post(
      "/api/autenticacao/login/ticket",
      { ticket },
      configPublico
    ),
  confirmarEmail: token =>
    ApiService2.query(
      "/api/autenticacao/confirmar-email",
      { token },
      configPublico
    ),
  solicitarConfirmacaoEmail: login =>
    ApiService2.post(
      "/api/autenticacao/confirmar-email/solicitar",
      { login },
      configPublico
    ),
  solicitarRedefinicaoSenha: login =>
    ApiService2.post(
      "/api/autenticacao/redefinir-senha/solicitar",
      { login },
      configPublico
    ),
  redefinirSenha: ({ token, senha }) =>
    ApiService2.post(
      "/api/autenticacao/redefinir-senha",
      { token, senha },
      configPublico
    )
};
